import { render } from "./ProductEngraving.vue?vue&type=template&id=82aa9e4c"
import script from "./ProductEngraving.vue?vue&type=script&lang=js"
export * from "./ProductEngraving.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/product/ProductEngraving.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "82aa9e4c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('82aa9e4c', __exports__)) {
    api.reload('82aa9e4c', __exports__)
  }
  
  module.hot.accept("./ProductEngraving.vue?vue&type=template&id=82aa9e4c", () => {
    api.rerender('82aa9e4c', render)
  })

}


export default __exports__